// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7cWNN","inner":"Footer_inner__2wJHm"};